import * as React from "react";
import {useContext, useEffect, useMemo, useState} from "react";
import PhotoCarousel from "./PhotoCarousel/PhotoCarousel";
import {IonButton, IonCol, IonGrid, IonRow, IonText} from "@ionic/react";
import {EGeoType} from "../../services/IconService";
import {Link, useParams} from "react-router-dom";
import {Feature} from "ol";
import {GeoJSON} from "ol/format";
import GeoFAService from "../../services/GeoFAService";

import GeoFaWidget from "./GeoFaWidget";

import styles from "./Facility.module.css";
import "./FacilityToolbox.css";

import FacilityMap from "./FacilitylMap/FacilityMap";
import MapContext from "../../contexts/MapContext";
import {useSwiper} from "swiper/react";
import {Trans, useTranslation} from "react-i18next";
import {getKommunenr, IRouterParams} from "../TheMap/TheMap";

import {CustomEvent} from '@piwikpro/react-piwik-pro'
import GeoFaWidgetBadge from "./GeoFaWidgetBadge/GeoFaWidgetBadge";
import {downloadOutline, linkOutline} from "ionicons/icons";
import {AppConfig} from "../../utils/AppConfig";

interface FacilityProps {
    objectId: string,
    className?: any,
    isObject?: boolean,
    parentCallback: (loaded: boolean) => void;
}

const Facility: React.FC<FacilityProps> = ({
                                               objectId, className,
                                               isObject,
                                               parentCallback
                                           }) => {

    const {getState} = useContext(MapContext);
    let {kommuneGUID} = useParams<IRouterParams>();

    const swiper = useSwiper();
    const {t} = useTranslation();

    const cls = `${isObject ? styles.isObject : styles.isNotObject}`;

    const [feature, setFeature] = useState<Feature>(
        new Feature()
    );

    // const [geoType, setGeotype] = useState<EGeoType>()
    const [loading, setLoading] = useState(true);
    const [showMap, setShowMap] = useState(false)
    const [oI, setOI] = useState<string>('')

    const featureProperties = useMemo<any>(() => {
        return feature?.getProperties() || {}
    }, [feature]);

    /*
    We check whether the ID comes via the context or the parameter
     */
    useEffect(() => {

        if (!objectId) {
            setOI(getState().featureIdInMapOverlay);
        } else {
            setOI(objectId)
        }

    }, [getState]);

    /*
    Let's get the full data of the feature
    if the geotype param is not given, we have to lookup which kind of Feature we have
   */
    useEffect(() => {

        const gAs = new GeoFAService(getKommunenr(kommuneGUID));

        /*
        Retrieve a feature fromm the backend.
         */
        async function fetchFeature() {

            // Look up the feature type by GUID
            const foundElement = getState().allFeatures.find((element: any) =>
                element.getProperties().objekt_id === oI);
            const temakode = foundElement.getProperties().temakode;

            let dL: any = {};

            // TODO: here, get from Store
            if (temakode === 5800) {
                dL = await gAs.getSingleFeatureFromGeoFA(oI, EGeoType.Point);
            } else if (temakode === 5802) {
                dL = await gAs.getSingleFeatureFromGeoFA(oI, EGeoType.Line);
            } else if (temakode === 5801) {
                dL = await gAs.getSingleFeatureFromGeoFA(oI, EGeoType.Polygon);
            } else if (temakode === 5607) {
                dL = await gAs.getSingleFeatureFromGeoFA(oI, EGeoType.LadestanderPoint);
            }

            let olFeature = new GeoJSON().readFeature(dL.features[0]);
            setFeature(olFeature);

            setShowMap(true);
            swiper.update()
            setLoading(false)

            CustomEvent.trackEvent('facility', 'show', objectId);

        }

        if (oI) {
            let startTime = performance.now()
            fetchFeature().catch((e) => {
                let endTime = performance.now()
                console.log('Load time: ', endTime - startTime);
                parentCallback(false)
            });
        }

    }, [oI])

    const buttons = [
        {
            id: 1,
            title: 'Hent GPX',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M14.2091 7.06982H17.2091V20.4998H3.78906V7.06982H6.78906" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M10.5 0.5V15.48" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M13.8399 12.1499L10.4999 15.4799L7.16992 12.1499" stroke="#105167" stroke-linejoin="round"/>
                </svg>
            )
        },
        {
            id: 2,
            title: 'Hent Folder',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <g clip-path="url(#clip0_7855_9731)">
                        <path d="M10.5153 20V5C9.29509 3.85516 9.36194 2.56001 6.04586 1.59998C2.72978 0.639942 1 1.12005 1 1.12005V17.6C1 17.6 4.31614 17.2801 5.75776 17.6C7.19937 17.92 7.19947 18.08 7.99236 18.4C8.78526 18.72 10.5153 20 10.5153 20Z" stroke="black" stroke-linejoin="round"/>
                        <path d="M10.6592 20.1317L10.5 5C11.7202 3.88168 12.1009 2.80416 15.417 1.86636C18.7331 0.928554 20.4629 1.39754 20.4629 1.39754V17.4959C20.4629 17.4959 17.1467 17.1833 15.7051 17.4959C14.2635 17.8085 14.2634 17.9648 13.4705 18.2773C12.6776 18.5899 10.6592 20.1317 10.6592 20.1317Z" stroke="black" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_7855_9731">
                            <rect width="21" height="21" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            )
        },
        {
            id: 3,
            title: 'Del',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                    <path d="M2.40476 4.2856C3.45673 4.2856 4.30952 3.43281 4.30952 2.38084C4.30952 1.32887 3.45673 0.476074 2.40476 0.476074C1.35279 0.476074 0.5 1.32887 0.5 2.38084C0.5 3.43281 1.35279 4.2856 2.40476 4.2856Z" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M2.40476 19.5239C3.45673 19.5239 4.30952 18.6711 4.30952 17.6191C4.30952 16.5671 3.45673 15.7144 2.40476 15.7144C1.35279 15.7144 0.5 16.5671 0.5 17.6191C0.5 18.6711 1.35279 19.5239 2.40476 19.5239Z" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M15.604 11.9047C16.656 11.9047 17.5087 11.0519 17.5087 9.99998C17.5087 8.94801 16.656 8.09521 15.604 8.09521C14.552 8.09521 13.6992 8.94801 13.6992 9.99998C13.6992 11.0519 14.552 11.9047 15.604 11.9047Z" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M13.9575 9.04729L4.05273 3.33301" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M13.9575 10.9521L4.05273 16.6664" stroke="#105167" stroke-linejoin="round"/>
                </svg>
            )
        },
        {
            id: 4,
            title: 'Til hjemmesiden',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M17.1587 7.77782L19.2545 9.8736L9.87368 19.2544L0.500083 9.88078L9.88086 0.5L11.9766 2.59578" stroke="#105167" stroke-linejoin="round"/>
                </svg>
            )
        },
        {
            id: 4,
            title: 'Offline',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M14.2091 7.06982H17.2091V20.4998H3.78906V7.06982H6.78906" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M10.5 0.5V15.48" stroke="#105167" stroke-linejoin="round"/>
                    <path d="M13.8399 12.1499L10.4999 15.4799L7.16992 12.1499" stroke="#105167" stroke-linejoin="round"/>
                </svg>
            )
        },
        {
            id: 4,
            title: 'Favorit',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                    <path d="M10.0107 18.3799C14.3583 15.2098 17.3093 11.95 18.9092 8.6084L18.9102 8.60547C19.6054 7.17701 19.6887 5.68109 19.1455 4.08691C18.6088 2.51209 17.6014 1.46769 16.1035 0.911133C14.9305 0.500136 13.953 0.460272 13.1406 0.727539C12.257 1.01826 11.5923 1.42433 11.1191 1.92969L10.3896 2.77832L10.0684 3.15234L9.69043 2.83691C9.56994 2.7364 9.4407 2.58962 9.30957 2.42383C9.21437 2.30356 8.96799 2.05925 8.5332 1.6709C8.13584 1.31598 7.74036 1.05932 7.34766 0.891602C6.95227 0.722816 6.44705 0.595338 5.82227 0.519531C5.27385 0.452991 4.63599 0.554849 3.89648 0.863281L3.8877 0.866211L3.61621 0.981445C2.28834 1.58256 1.37498 2.60688 0.864258 4.08887C0.31443 5.68437 0.38846 7.18134 1.07129 8.60938C2.76327 11.9925 5.73101 15.2511 10.0107 18.3799Z" stroke="#105167"/>
                </svg>
            )
        },
        // Add more buttons as needed
    ];

    return (
        <>
        <IonGrid className={cls}>
            <IonRow>
                <PhotoCarousel objectId={oI} properties={featureProperties}></PhotoCarousel>
            </IonRow>
        </IonGrid>
        {AppConfig.facilityToolbox &&
            <IonGrid>
                <IonRow className={'ir'}>
                    {buttons.map((button) => (
                        <IonCol
                            key={button.id}
                            size="2" // 2 columns on mobile
                            sizeSm="4" // 3 columns on small screens
                            sizeMd="3" // 4 columns on medium screens
                            sizeLg="2" // 6 columns on large screens
                        >
                            <div className="button-container">
                                <IonButton
                                    shape="round"
                                    className="circular-button"
                                    onClick={() => console.log(`${button.title} clicked`)}
                                >
                                    <div className="icon-wrapper">
                                        {button.icon}
                                    </div>
                                </IonButton>
                                <IonText className="button-title">
                                    <p>{button.title}</p>
                                </IonText>
                            </div>
                        </IonCol>
                    ))}
                </IonRow>
            </IonGrid>
        }

    <IonGrid className={cls}>

        {featureProperties.beskr &&
            <IonRow>
                <GeoFaWidget properties={featureProperties}
                             typeCodes={[]}
                             field={'beskr'}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.beskrivels &&
            <IonRow>
                <IonCol class={styles.paddingLeftNull}>
                    <GeoFaWidget properties={featureProperties}
                                 typeCodes={[6052]}
                                 field={'beskrivels'}
                                 de_field={'d_k_beskr'}
                                 en_field={'uk_k_beskr'}></GeoFaWidget>
                </IonCol>
            </IonRow>
        }

        {featureProperties.laengde &&
            <IonRow>

                <GeoFaWidget properties={featureProperties}
                             label={t('laengde')}
                             typeCodes={[]}
                             field={'laengde'}
                             translateValue={true}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.gpx_link &&
            <IonRow>
                <IonCol class={styles.paddingLeftNull}>
                    <Link className={styles.small}
                          to={{pathname: featureProperties.gpx_link}} target="_blank">
                        <GeoFaWidgetBadge icon={downloadOutline}>
                            <Trans i18nKey="getGpx"></Trans>
                        </GeoFaWidgetBadge>
                    </Link>
                    <br/>
                </IonCol>
            </IonRow>
        }

        {featureProperties.folde_link &&
            <IonRow>
                <IonCol class={styles.paddingLeftNull}>
                    <Link className={styles.small}
                          to={{pathname: featureProperties.folde_link}} target="_blank">
                        <GeoFaWidgetBadge icon={downloadOutline}>
                            <Trans i18nKey="getFolder"></Trans>
                        </GeoFaWidgetBadge>
                    </Link>
                    <br/>
                </IonCol>
            </IonRow>
        }

        {featureProperties.link &&
            <IonRow>
                <IonCol class={styles.paddingLeftNull}>
                    <Link className={styles.noUnderline} to={{pathname: featureProperties.link}} target="_blank">
                        <GeoFaWidgetBadge icon={linkOutline}>
                            <Trans i18nKey="toHomepage"></Trans>
                        </GeoFaWidgetBadge>
                    </Link>
                    <br/>
                </IonCol>
            </IonRow>
        }

        {featureProperties.tilgaeng_beskriv &&
            <IonRow>
                <GeoFaWidget properties={featureProperties}
                             typeCodes={[5, 4411, 3012, 3091, 2012, 1302, 2092, 1291, 1012, 1222]}
                             field={'tilgaeng_beskriv'}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.saeson_bem && <IonRow>
            <GeoFaWidget label={t('canBeBooked')}
                         properties={featureProperties}
                         typeCodes={[3012, 4111]}
                         translateValue={true}
                         field={'book'}></GeoFaWidget>
        </IonRow>
        }

        {featureProperties.lang_beskr &&
            <IonRow>
                <GeoFaWidget properties={featureProperties}
                             typeCodes={[]}
                             field={'lang_beskr'}
                             de_field={'d_l_beskr'}
                             en_field={'uk_l_beskr'}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {/*
                {featureProperties.ansva_v &&
                    <IonRow>

                        <GeoFaWidget properties={featureProperties}
                                     label={t('maintainedBy')}
                                     typeCodes={[1061, 6052, 6062, 4191, 4411]}
                                     field={'ansva_v'}
                                     translateValue={true}
                                     dangerous={true}></GeoFaWidget>
                    </IonRow>
                }
                */}

        {featureProperties.ansvar_org &&
            <IonRow>

                <GeoFaWidget properties={featureProperties}
                             label={t('maintainedBy')}
                             typeCodes={[1061, 6052, 6062, 4191, 4411]}
                             field={'ansvar_org'}
                             translateValue={false}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.kontak_ved &&
            <IonRow>

                <GeoFaWidget properties={featureProperties}
                             label={t('contact')}
                             typeCodes={[1061, 6052, 6062, 4191, 4411, 888]}
                             field={'kontak_ved'}
                             translateValue={false}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.handicap &&
            <IonRow>
                <GeoFaWidget properties={featureProperties}
                             typeCodes={[4411, 3012, 3091, 2012, 1302, 2092, 5072]}
                             field={'handicap'}
                             translateValue={true}
                             dangerous={true}></GeoFaWidget>
            </IonRow>
        }

        {featureProperties.book && <IonRow>
            <GeoFaWidget label={t('canBeBooked')}
                         properties={featureProperties}
                         typeCodes={[3012, 4111]}
                         translateValue={true}
                         field={'book'}></GeoFaWidget>
        </IonRow>
        }

        {featureProperties.betaling && <IonRow>
            <GeoFaWidget label={t('payment')}
                         properties={featureProperties}
                         typeCodes={[3012, 1302]}
                         translateValue={true}
                         field={'betaling'}></GeoFaWidget>
        </IonRow>
        }

        {showMap &&
            <IonRow className={styles.mapContainer}>
                <FacilityMap objectId={oI}></FacilityMap>
            </IonRow>
        }

    </IonGrid>

</>
)

}

export default Facility;
